import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints.ts';
import { pageTemplate } from '../../../styles/theme';
import { CAROUSEL_ITEM_PADDING } from '../../Carousel';

export const PARTIAL_VISIBILITY_GUTTER = {
    xs: 10,
    sm: 10,
    md: 10,
    lg: 0,
    xl: 0,
};
export const LAYOUT_ITEMS = {
    xs: 2,
    sm: 3,
    md: 4,
    lg: 6,
    xl: 8,
};
export const imgSizes = [
    `(min-width: ${BREAKPOINTS.xl}) calc(((100vw - ${(parseFloat(pageTemplate.paddingLeftRight.lg) - CAROUSEL_ITEM_PADDING.xl) * 2}px) / ${LAYOUT_ITEMS.xl}) - ${CAROUSEL_ITEM_PADDING.xl * 2}px),`,
    `(min-width: ${BREAKPOINTS.lg}) calc(((100vw - ${(parseFloat(pageTemplate.paddingLeftRight.lg) - CAROUSEL_ITEM_PADDING.lg) * 2}px) / ${LAYOUT_ITEMS.lg}) - ${CAROUSEL_ITEM_PADDING.lg * 2}px),`,
    `(min-width: ${BREAKPOINTS.md}) calc(((100vw - ${((parseFloat(pageTemplate.paddingLeftRight.md) - CAROUSEL_ITEM_PADDING.md) * 2) + PARTIAL_VISIBILITY_GUTTER.md}px) / ${LAYOUT_ITEMS.md}) - ${CAROUSEL_ITEM_PADDING.md * 2}px),`,
    `(min-width: ${BREAKPOINTS.sm}) calc(((100vw - ${((parseFloat(pageTemplate.paddingLeftRight.xs) - CAROUSEL_ITEM_PADDING.sm) * 2) + PARTIAL_VISIBILITY_GUTTER.sm}px) / ${LAYOUT_ITEMS.sm}) - ${CAROUSEL_ITEM_PADDING.sm * 2}px),`,
    `calc(100vw - ${((parseFloat(pageTemplate.paddingLeftRight.xs) - CAROUSEL_ITEM_PADDING.xs) * 2) + PARTIAL_VISIBILITY_GUTTER.xs + (CAROUSEL_ITEM_PADDING.xs * 2)}px)`,
].join('');
